import * as _includes from 'lodash/includes';

export function includes(obj: any, value: any, fromIndex: number = 0): boolean {
  return _includes(obj, value, fromIndex);
}
